/* 
* <license header>
*/

import React from 'react'
import { Provider, defaultTheme, Grid, View } from '@adobe/react-spectrum'
import ErrorBoundary from 'react-error-boundary'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import {Text, Heading} from '@adobe/react-spectrum'
import { JobProvider } from '../context/JobContext';

import { Voxify } from './Voxify'
import Jobs from './Jobs'
function App (props) {
  console.log('runtime object:', props.runtime)
  console.log('ims object:', props.ims)

  // use exc runtime event handlers
  // respond to configuration change events (e.g. user switches org)
  props.runtime.on('configuration', ({ imsOrg, imsToken, locale }) => {
    console.log('configuration change', { imsOrg, imsToken, locale })
  })
  // respond to history change events
  props.runtime.on('history', ({ type, path }) => {
    console.log('history change', { type, path })
  })

  return (
    <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
      <Router>
        <Provider theme={defaultTheme} colorScheme={'dark'}>
        <JobProvider>

          <Grid
            areas={[
              'title title',
              'sidebar content'
            ]}
            columns={['1.25fr', '3fr']}
            rows={['auto']}
            width='1600px'
            marginStart="auto"
            marginEnd="auto"
            gap='size-200'
          >
            <View gridArea='title' padding='size-200'>
              <Heading level={1}>
                DXPE Voxify
              </Heading>
            </View>
            <View gridArea='sidebar' padding='size-200'>
              <Jobs />
            </View>
            <View gridArea='content' padding='size-200'>
              <Voxify ims={props.ims} />
            </View>
          </Grid>
          </JobProvider>
        </Provider>
      </Router>
    </ErrorBoundary>
  )

  // Methods

  // error handler on UI rendering failure
  function onError (e, componentStack) { }

  // component to show if UI fails rendering
  function fallbackComponent ({ componentStack, error }) {
    return (
      <React.Fragment>
        <h1 style={{ textAlign: 'center', marginTop: '20px' }}>
          Something went wrong :(
        </h1>
        <pre>{componentStack + '\n' + error.message}</pre>
      </React.Fragment>
    )
  }
}

export default App
